module.exports = {"TXTCLI_Share_link":{"id":"TXTCLI_Share_link","defaultMessage":"Link teilen","track":"Share link"}}